import {
  GET_TRANSLATIONS,
  SHOW_GLOBAL_LOADER,
  HIDE_GLOBAL_LOADER,
  SHOW_GLOBAL_ERROR,
  CLEAR_GLOBAL_ERROR,
  GET_LOCATIONS,
  GET_LOCATIONS_SUCCESS,
  GET_LOCATIONS_FAILURE,
  GET_HOME_CHARGERS,
  GET_HOME_CHARGERS_SUCCESS,
  GET_HOME_CHARGERS_FAILURE,
  CLEAR_HOME_CHARGERS,
  GET_3RD_PARTY_CHARGERS,
  GET_3RD_PARTY_CHARGERS_SUCCESS,
  GET_3RD_PARTY_CHARGERS_FAILURE,
  GET_SELECTED_LOCATION_DETAIL,
  GET_SELECTED_LOCATION_DETAIL_SUCCESS,
  GET_SELECTED_LOCATION_DETAIL_FAILURE,
  GET_LOCATIONS_DETAIL,
  GET_LOCATIONS_DETAIL_SUCCESS,
  GET_LOCATIONS_DETAIL_FAILURE,
  CLEAR_SELECTED_LOCATION_DETAIL,
  SET_MAP_MODE,
  SET_FILTER,
  SET_CURRENT_LOCATION,
  SET_HOME_CHARGERS_DISPLAY,
  GET_HOME_CHARGERS_V2,
  GET_LOCATIONS_V2,
} from './types';

const action = type => payload => ({
  type,
  payload,
});

export const getTranslations = action(GET_TRANSLATIONS);

export const showGlobalLoader = action(SHOW_GLOBAL_LOADER);
export const hideGlobalLoader = action(HIDE_GLOBAL_LOADER);

export const showGlobalError = action(SHOW_GLOBAL_ERROR);
export const clearGlobalError = action(CLEAR_GLOBAL_ERROR);

export const getLocations = action(GET_LOCATIONS);
export const getLocationsV2 = action(GET_LOCATIONS_V2);
export const getLocationsSuccess = action(GET_LOCATIONS_SUCCESS);
export const getLocationsFailure = action(GET_LOCATIONS_FAILURE);

export const getHomeChargers = action(GET_HOME_CHARGERS);
export const getHomeChargersV2 = action(GET_HOME_CHARGERS_V2);
export const getHomeChargersSuccess = action(GET_HOME_CHARGERS_SUCCESS);
export const getHomeChargersFailure = action(GET_HOME_CHARGERS_FAILURE);
export const setHomeChargersDisplay = action(SET_HOME_CHARGERS_DISPLAY);
export const clearHomeChargers = action(CLEAR_HOME_CHARGERS);

export const get3rdPartyChargers = action(GET_3RD_PARTY_CHARGERS);
export const get3rdPartyChargersSuccess = action(GET_3RD_PARTY_CHARGERS_SUCCESS);
export const get3rdPartyChargersFailure = action(GET_3RD_PARTY_CHARGERS_FAILURE);

export const getSelectedLocationDetail = action(GET_SELECTED_LOCATION_DETAIL);
export const getSelectedLocationDetailSuccess = action(GET_SELECTED_LOCATION_DETAIL_SUCCESS);
export const getSelectedLocationDetailFailure = action(GET_SELECTED_LOCATION_DETAIL_FAILURE);
export const clearSelectedLocationDetail = action(CLEAR_SELECTED_LOCATION_DETAIL);

export const getLocationsDetail = action(GET_LOCATIONS_DETAIL);
export const getLocationsDetailSuccess = action(GET_LOCATIONS_DETAIL_SUCCESS);
export const getLocationsDetailFailure = action(GET_LOCATIONS_DETAIL_FAILURE);

export const setMapMode = action(SET_MAP_MODE);
export const setFilter = action(SET_FILTER);
export const setCurrentLocation = action(SET_CURRENT_LOCATION);
